import Store from 'store/store';
import * as base from 'store/bolt/index.js';
import 'store/bolt/geo';
import { accessNested } from 'utils/utils';
import { getHeaderHeight } from 'utils/bolt/index';
import { smoothScrollTo } from 'utils/smoothScroll';

function getSectionElement(id) {
	const store = Store.get();
	const noSlug = store.appData?.pages?.[id];
	if (!noSlug) {
		const pages = accessNested(store, 'appData.pages', null);
		const parentSection = pages && Object.keys(pages).filter(page => pages[page].slug === id)[0];
		id = parentSection || id;
	}
	try {
		return document.querySelector(`[data-section="${id}"]`);
	} catch (e) {
		return null;
	}
}

function getMobileOffset(store) {
	const hasSonyHeader = accessNested(store, 'appData.options.sonyFeatures.sonyHeader', false);

	if (hasSonyHeader) {
		return 58;
	} else {
		return getHeaderHeight();
	}
}

function getDesktopOffset(store, id) {
	const hasSonyHeader = accessNested(store, 'appData.options.sonyFeatures.sonyHeader', false);
	const isHubPage = accessNested(store, `appData.pages.${id}.component`, '') === 'hub';

	if (hasSonyHeader || isHubPage) {
		return 34;
	} else {
		return 0;
	}
}

let sectionLoadVersion = 0;
Store.on('CHANGE_ACTIVE_SECTION', (id, options) => {
	options = options || {};
	if (options.mainPage && !getSectionElement(options.mainPage)) {
		options.instant = false;
	}
	const store = Store.get();

	let toElem = getSectionElement(id);

	const isDesktop = accessNested(store, 'client.isDesktopSize', false);
	const hasUarHeader = accessNested(store, 'appData.header.uarHeader');
	let scrollOffset = isDesktop ? getDesktopOffset(store, id) : getMobileOffset(store);

	if (id === 'boltHome') {
		scrollOffset = 0;
	}

	if (id === 'boltSynopsis') {
		scrollOffset = 20;
	}

	if (hasUarHeader) {
		scrollOffset = isDesktop ? 80 : 64;
	}

	// for creative projects and whatnot
	const forceScrollOffsetDesktop = store?.appData?.options?.forceScrollOffsetForSection?.[id]?.desktop || store?.appData?.options?.forceScrollOffsetDesktop;
	const forceScrollOffsetMobile = store?.appData?.options?.forceScrollOffsetForSection?.[id]?.mobile || store?.appData?.options?.forceScrollOffsetMobile;
	if (forceScrollOffsetMobile) {
		scrollOffset = +forceScrollOffsetMobile;
	}
	if (isDesktop && forceScrollOffsetDesktop) {
		scrollOffset = +forceScrollOffsetDesktop;
	}

	let ignoreNextScroll = false;
	const go = toElem => {
		if (!toElem) {
			return;
		}
		if (options.fromPopState && Store.get().client.scrollPos) {
			return;
		}
		const scroller = document.getElementById('mainScroll');
		ignoreNextScroll = true;
		smoothScrollTo(scroller, toElem, options.instant ? 0 : (options.scrollDuration || 400), {
			...options,
			offset: scrollOffset,
			force: true,
			callback: () => Store.emit('CLOSE_ALL_OVERLAYS')
		});
	};

	let version = ++sectionLoadVersion;
	const listener = (loadedId, dom) => {
		if (version !== sectionLoadVersion) {
			setTimeout(() => Store.off('SECTION_LOADED', listener), 0);
			return;
		}
		if (!options.instant) {
			if (loadedId !== id) {
				return;
			}
			setTimeout(() => Store.off('SECTION_LOADED', listener), 0);
		}
		go(loadedId === id ? dom : getSectionElement(id));
	};

	// If section has already loaded scroll to it, otherwise try to load it
	if (toElem) {
		go(toElem);
		Store.off('SECTION_LOADED', listener);
	} else {
		if (id === options.mainPage) {
			document.getElementById('mainScroll')?.scrollTo(0, 0);
		}
		Store.on('SECTION_LOADED', listener);
		Store.emit('LOAD_SECTION', id);
	}
	if (options.instant) {
		// Remove the automatic scrolling to the desired section once the user has scrolled
		let scrollListener = () => {
			if (ignoreNextScroll) {
				ignoreNextScroll = false;
				return;
			}
			Store.off('SECTION_LOADED', listener);
			window.removeEventListener('scroll', scrollListener, true);
		};
		window.addEventListener('scroll', scrollListener, true);
	}
});